import React from 'react';
import { LockOutlined } from '@ant-design/icons';

export const DisplayName = (name: string) => {
  return (
    <span>
      {name === 'private' ? (
        <span>
          <LockOutlined /> 비공개
        </span>
      ) : (
        <span>{name}</span>
      )}
    </span>
  );
};
